import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1b0b4566"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "StepReceivers" }
const _hoisted_2 = { class: "StepReceivers__title" }
const _hoisted_3 = {
  key: 0,
  class: "flex items-center"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-file-excel mr-2" }, null, -1))
const _hoisted_5 = {
  key: 1,
  class: "flex items-center justify-between"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "StepReceivers__title" }, "Получатель выбран", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times mr-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_file_loader = _resolveComponent("file-loader")!
  const _component_the_button = _resolveComponent("the-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.state.directions.length)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.stepNumber) + ". Выберите получателя", 1),
          (_ctx.opened)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_component_file_loader, {
                  accept: ".xlsx, .xls, .csv",
                  placeholder: "Загрузить из Excel",
                  disabled: _ctx.disabled,
                  class: "primary small text mr-3",
                  onFileLoaded: _ctx.emitSubmit
                }, {
                  default: _withCtx(() => [
                    _hoisted_4,
                    _createTextVNode(" Загрузить из excel ")
                  ]),
                  _: 1
                }, 8, ["disabled", "onFileLoaded"])
              ]))
            : _createCommentVNode("", true)
        ], 64))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _hoisted_6,
          _createVNode(_component_the_button, {
            class: "second small text",
            disabled: _ctx.disabled,
            onClick: _ctx.emitReset
          }, {
            default: _withCtx(() => [
              _hoisted_7,
              _createTextVNode(" Сбросить ")
            ]),
            _: 1
          }, 8, ["disabled", "onClick"])
        ]))
  ]))
}